import React from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import { useSuperDuper } from '../../context/SuperDuperContext';
import SubscriptionRow from './SubscriptionRow';

const COLUMNS = [
  'Name',
  'Email',
  'Phone',
  "Kid's Age",
  'Edition',
  'Period',
  'Coupon Code',
  'Subscription ID',
  'Payment ID',
  'Status',
  'Created At',
  'Cancelled At'
];

const SubscriptionsTable = ({ rows }) => {
  const {
    subscriptionSubTab,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    downloadCSV
  } = useSuperDuper();

  return (
    <>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        {(subscriptionSubTab === 0 || subscriptionSubTab === 1) && (
          <Button
            variant="outlined"
            color="success"
            onClick={downloadCSV}
            startIcon={<span>📥</span>}
            fullWidth
            sx={{ maxWidth: { sm: 'auto' }, width: { xs: '100%', sm: 'auto' } }}
          >
            Download CSV
          </Button>
        )}
      </Box>
      <TableContainer component={Paper} sx={{ maxWidth: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
        <Table sx={{ minWidth: 1200 }} aria-label="subscriptions table">
          <TableHead>
            <TableRow>
              {COLUMNS.map((column) => (
                <TableCell key={column}>{column}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((subscription) => (
                <SubscriptionRow key={subscription._id} subscription={subscription} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{
          '.MuiTablePagination-toolbar': {
            flexWrap: 'wrap',
            justifyContent: { xs: 'center', sm: 'flex-end' },
            px: { xs: 0, sm: 2 }
          },
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }
        }}
      />
    </>
  );
};

export default SubscriptionsTable;
